import { useCallback, useMemo } from 'react';
import { useEntityCache } from './useEntityCache';
import { getCamera } from '../services/cameras';

/**
 * Имя и (при необходимости) таймзона камеры по camera_id, которого нет в
 * самом списке — правила, события, заявки не всегда несут имя камеры сами.
 * Тонкая обёртка над useEntityCache (ТЗ, finding 5): единственная реализация
 * вместо четырёх копий в ViolationRulesTab/ViolationEventsTab/
 * ChangeRequestsTab/MyChangeRequestsTab.
 *
 * `!item.camera_name` в селекторе id — не костыль под конкретную вкладку:
 * у правил и событий такого поля вообще нет (условие всегда true), а у
 * заявок оно иногда уже приходит с backend, и тогда лишний GET не нужен.
 */
const mapCamera = (camera) => ({ name: camera?.name || '', timezone: camera?.display_timezone || '' });

export const useCameraNames = (items) => {
  const cameraIds = useMemo(
    () => (Array.isArray(items)
      ? items.filter((item) => !item?.camera_name).map((item) => item?.camera_id).filter(Boolean)
      : []),
    [items]
  );

  const { byId } = useEntityCache(cameraIds, getCamera, mapCamera);

  const cameraLabel = useCallback((cameraId) => {
    if (!cameraId) return '';
    return byId[cameraId]?.name || `Камера #${cameraId}`;
  }, [byId]);

  const cameraTimezone = useCallback((cameraId) => byId[cameraId]?.timezone || undefined, [byId]);

  return { cameraLabel, cameraTimezone };
};

export default useCameraNames;
